import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";

export function ReassignVisitorModal({ visitor, onClose, onReassigned }) {
  const [reps, setReps] = useState([]);
  const [repId, setRepId] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/website-visitors/reps").then(({ data }) => setReps(data)).catch(() => setReps([]));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!repId) {
      toast.error("Pick a rep to reassign to");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post(`/admin/website-visitors/${visitor.id}/reassign`, { rep_id: repId });
      toast.success(data.message);
      onReassigned();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4" data-testid="reassign-visitor-modal-overlay">
      <form onSubmit={handleSubmit} className="bg-igc-surface border border-igc-gold/30 max-w-md w-full p-6 relative" data-testid="reassign-visitor-modal">
        <button type="button" data-testid="reassign-visitor-modal-close-button" onClick={onClose} aria-label="Close" className="absolute top-4 right-4 text-igc-muted hover:text-igc-cream">
          <X size={18} />
        </button>
        <p className="font-serif text-xl text-igc-cream mb-1 pr-8">Reassign Lead</p>
        <p className="text-igc-muted text-xs mb-4">
          Currently auto-assigned to <span className="text-igc-cream">{visitor.assigned_rep_name || "a rep"}</span> — pick a different rep below.
        </p>

        <div>
          <label className="text-igc-muted text-xs uppercase tracking-widest block mb-1">Reassign To</label>
          <select data-testid="reassign-visitor-rep-select" required value={repId} onChange={(e) => setRepId(e.target.value)} className="w-full bg-igc-bg border border-igc-gold/15 px-3 py-2 text-sm text-igc-cream">
            <option value="" disabled>Select a rep...</option>
            {reps.map((r) => (
              <option key={r.id} value={r.id}>{r.display_name} ({r.user_id})</option>
            ))}
          </select>
        </div>

        <button data-testid="reassign-visitor-submit-button" disabled={saving} type="submit" className="mt-5 w-full text-sm px-4 py-2.5 bg-igc-gold text-igc-goldText font-medium hover:bg-igc-gold/90 transition-colors disabled:opacity-50">
          {saving ? "Reassigning..." : "Confirm Reassign"}
        </button>
      </form>
    </div>,
    document.body
  );
}
